import React, { createContext, useState } from 'react';

import TouchpointContactTypeData from './TouchpointContactTypeData';

export const TouchpointContactTypeStateContext = createContext();

const TouchpointContactTypeContextProvider = ({ children }) => {
  const stateHook = useState(TouchpointContactTypeData.INITIAL_STATE);

  return (
    <TouchpointContactTypeStateContext.Provider value={stateHook}>
      {children}
    </TouchpointContactTypeStateContext.Provider>
  );
};

export default TouchpointContactTypeContextProvider;